import React, { useEffect } from 'react';
import styled from 'styled-components';
import SettingWidgetIcon from '../../Common/SvgIcon/SettingWidgetIcon';
import Tabs from './Tabs';

const Sidebar = styled.div`
  border-right: 1px solid rgba(162, 162, 162, 0.35);
`;

const SettingHeader = styled.div`
  width: 79%;
  display: flex;
  justify-content: space-between;
  margin: 20px auto;
  padding-bottom: 18px;
  font-weight: 600;
  font-size: 20px;
  position: relative;

    align-items: center;
  &::after {
    position: absolute;
    content: '';
    top: 90%;
    left: 50%;
    transform: translate(-50%);
    width: 105%;
    height: 1px;
    border-radius: 10px;
    background-color: rgba(99, 99, 99, 0.2);
  }
    & > div{
    text-align: justify;
    }
`;

const NewSideBar = ({
  headerName,
  tabs,
  initialActiveTab = 1,
  buttonTitle,
}) => {
  // console.log(initialActiveTab,tabs,"initialActiveTab");

  return (
    <Sidebar>
      <SettingHeader>
        <div>{headerName}</div>
        {SettingWidgetIcon}
      </SettingHeader>
      {tabs.map((data) => (
        <Tabs
          value={data}
          active={initialActiveTab}
          key={data.id}
          name={headerName}
          buttonTitle={buttonTitle}
        />
      ))}
    </Sidebar>
  );
};

export default NewSideBar;
